import { gql } from "@apollo/client"
import { api } from "lib/graphql/api"
import { query } from "lib/graphql/query"

export const getScheduleEditorLegislation = api(async function getScheduleEditorLegislation({ legacyIds, projectId }) {
    return query(
        gql`
            query GetScheduleEditorLegislation($legacyIds: [String!]!, $projectId: String!) {
                getScheduleEditorLegislation(legacyIds: $legacyIds, projectId: $projectId) {
                    legacyId
                    title
                    redirectUrl
                }
            }
        `,
        { legacyIds, projectId },
        { returns: "getScheduleEditorLegislation" }
    )
})
